import {
  CreateCommandePayload,
  CommandeLineItem,
} from "modules/commande/types/commande.interface";
import { FunctionComponent, useEffect, useState } from "react";
import { Autocomplete, Option } from "components/fields/autoCompleteField";
import { useGetArticles } from "modules/article/api/src/article.api";
import { useGetAllDevis } from "modules/devis/api/src/devis.api";

type SelectDevisProps = {
  formValues: CreateCommandePayload;
  setFormValues: (values: CreateCommandePayload) => void;
};

export const SelectDevis: FunctionComponent<SelectDevisProps> = ({
  formValues,
  setFormValues,
}) => {
  const [searchValue, setSearchValue] = useState("");
  const { data: articlesData } = useGetArticles(undefined);
  const { data: devisData, refetch, isLoading } = useGetAllDevis(searchValue, 30);
  const devisList = devisData?.pages.flatMap((page) => page.data) || [];

  useEffect(() => {
    refetch();
  }, [searchValue, refetch]);

  const options = devisList
    .filter((devis) => {
      const documentNumber = `${devis.documentNumber.number}`;
      return documentNumber.toLowerCase().includes(searchValue.toLowerCase());
    })
    .map((devis) => {
      const documentNumber = `${devis.documentNumber.number}`;
      return {
        id: devis._id,
        name: `${documentNumber}`,
      };
    });

  const handleOptionChange = (option: Option) => {
    const selectedDevis = devisList.find((d) => d._id === option.id);
    if (!selectedDevis) return;

    const allArticles = articlesData?.pages.flatMap((p) => p.data) || [];

    const updatedLineItems: CommandeLineItem[] = selectedDevis.lineItems.map(
      (item, index) => ({
        _id: `${selectedDevis._id}-${index}`,
        checked: false,
        articleId: item.articleId,
        description: item.description,
        quantity: item.quantity,
        reductionType: item.reductionType,
        reductionAmount: item.reductionAmount,
        total: item.totalTTC,
        vatAmount: item.vatAmount,
        totalTTC: item.totalTTC,
        totalHT: item.totalHT,
        priceHT:
          allArticles.find((a) => a._id === item.articleId)?.priceHT || item.priceHT,
      })
    );

    // Adaptation de la payload pour le formulaire de commande.
    setFormValues({
      ...formValues,
      devisId: selectedDevis._id,
      clientId: selectedDevis.clientId,
      lineItems: updatedLineItems,
      totalTTC: selectedDevis.totalTTC,
      totalHT: selectedDevis.totalHT,
    });
  };

  useEffect(() => {
    if (searchValue === "" && formValues.devisId) {
      const devis = options.find((option) => option.id === formValues.devisId);
      setSearchValue(devis?.name || "");
    }
  }, [formValues.devisId, options, searchValue]);

  return (
    <Autocomplete
      options={options}
      onSelect={handleOptionChange}
      value={[formValues.devisId]}
      label="Sélectionner un devis"
      searchValue={searchValue}
      setSearchValue={setSearchValue}
      isLoading={isLoading}
    />
  );
};
